import { GlobalStyle } from '@defa/defa-component-library';
import { ReactNode } from 'react';

import { Footer } from '../footer';
import { Header } from '../header';
import { SupportSection } from '../support-section';
import { Root } from './app-layout.styles';

export function AppLayout({ children }: { children: ReactNode }) {
    return (
        <Root>
            <GlobalStyle />
            <Header />
            {children}
            <SupportSection />
            <Footer />
        </Root>
    );
}
